// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tile-img[data-v-3ae3e1b1]{position:relative}@media(max-width:1279px){.tile-img.big[data-v-3ae3e1b1]{min-height:auto;padding-top:95.7746478873%}.tile-img.wide[data-v-3ae3e1b1]{min-height:auto;padding-top:45.6338028169%}}.tile-img img[data-v-3ae3e1b1]{display:block;height:100%;left:0;-o-object-fit:cover;object-fit:cover;position:absolute;top:0;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
